import { render, staticRenderFns } from "./AskForAnInvoice.vue?vue&type=template&id=9b9d23c8&scoped=true"
import script from "./AskForAnInvoice.vue?vue&type=script&lang=js"
export * from "./AskForAnInvoice.vue?vue&type=script&lang=js"
import style0 from "./AskForAnInvoice.vue?vue&type=style&index=0&id=9b9d23c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9d23c8",
  null
  
)

export default component.exports